import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 27.5rem;
  background: #fff;
  border-radius: 0.17648rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;

export const Title = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  color: #212326;
  padding-top: 1.875rem;
`;

export const SubTitle = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 1.125rem;

  color: #585e66;

  padding-top: 0.9375rem;
`;

export const FlowName = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 1.875rem;

  color: #585e66;

  padding-top: 3.3125rem;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;

  padding-top: 4.1875rem;
  padding-bottom: 1.875rem;
`;

export const DivIcon = styled.div`
  position: absolute;
  top: 1.125rem;
  right: 0.9375rem;
  cursor: pointer;

  svg {
    width: 0.75rem;
    height: 0.75rem;
    &:hover {
      path,
      rect {
        stroke: #40e5a0;
      }
    }
  }
`;
